module.exports = __webpack_public_path__ + "static/img/paybis.6f0015b7.png";